import * as React from 'react'
import styled, { css } from 'styled-components'
import { SPACE } from '../../styles/constants'
import { calcFontScale } from '../../styles/calcFontScale'
import { withProps } from '../../styles/themed-components'
import { lighten } from 'polished'
import { antiAlias } from '../../styles/antiAlias'
// @ts-ignore
import * as theme from 'styled-theming'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'micro' | 'default' | 'puffy'
  variant?: 'default' | 'primary'
  letterCase?: 'default' | 'uppercase' | 'lowercase' | 'capitalize'
  fullWidth?: boolean
}

export const Button: React.SFC<Props> = ({
  size = 'default',
  variant = 'default',
  letterCase = 'capitalize',
  fullWidth,
  children,
  ...props
}) => (
  <Wrapper size={size} variant={variant} letterCase={letterCase} fullWidth={fullWidth} {...props}>
    {children}
  </Wrapper>
)

const colors = {
  button: theme.variants('mode', 'variant', {
    default: {
      light: css`
        border-color: ${(props: any) => lighten(0.75, props.theme.color.black)};
        ${(props: any) => antiAlias(0.25, lighten(0.75, props.theme.color.black))};
        color: ${(props: any) => lighten(0.5, props.theme.color.black)};
      `,
      dark: css`
        background-color: ${(props: any) => lighten(0.125, props.theme.color.black)};
        border-color: ${(props: any) => lighten(0.125, props.theme.color.black)};
        ${(props: any) => antiAlias(0.25, lighten(0.125, props.theme.color.black))};
        color: ${(props: any) => lighten(0.5, props.theme.color.black)};
      `,
    },
    primary: {
      light: css`
        background-color: ${(props: any) => props.theme.color.primary};
        border-color: ${(props: any) => props.theme.color.primary};
        ${(props: any) => antiAlias(0.5, props.theme.color.primary)};
        color: ${(props: any) => lighten(1, props.theme.color.black)};
      `,
      dark: css`
        background-color: ${(props: any) => props.theme.color.primary};
        border-color: ${(props: any) => props.theme.color.primary};
        ${(props: any) => antiAlias(0.5, props.theme.color.primary)};
        color: ${(props: any) => lighten(1, props.theme.color.black)};
      `,
    },
  }),
}

// Style
const Wrapper = withProps<Props>()(styled.button)`
	background-color: transparent;
	border-width: 1px;
	border-style: solid; 
  border-radius: 2px;
  box-sizing: border-box;
  cursor: pointer;
  font-weight: bold;
  left: 0;
  position: relative;
  text-transform: ${(props: Props) => props.letterCase};
  transition: all 150ms ease-in-out;
  top: 0;
	${colors.button};
  ${SPACE.inset.squish.s};
  ${SPACE.stack.s}; 
  ${calcFontScale(0)};

  &:focus {
    outline: 0;
    top: -2px;
  }
  &:active {
    top: 1px;
  }

  ${(props: Props) =>
    props.size === 'micro' &&
    `
		${SPACE.inset.squish.xs};
		${SPACE.stack.xs};
		${calcFontScale(-1)};
	`};

  ${(props: Props) =>
    props.size === 'puffy' &&
    `
		${SPACE.inset.squish.m};
	`};

  ${(props: Props) =>
    props.disabled &&
    `
		opacity: 0.5;
		cursor: not-allowed;
		&:hover {
			top: 0;
		}
	`};

  ${(props: Props) =>
    props.fullWidth &&
    `
		display: block;
		width: 100%;
	`};
`



// WEBPACK FOOTER //
// ./src/components/Button/index.tsx